import * as types from '@/modules/Terminals/store/mutation-types'
import termApi from '@/modules/Terminals/api/'
import { calculate_end_time } from "@/utils/time";


export const defaultModuleName = "terminals";
export default {
  namespaced: true,
  state: {
    isLoading: true,
    organizationTerminals: [],
    terminalGeneral: { organization: {} },
    terminalService: {},
    terminalMaintenance: {},
    terminalSchedules:[],
    terminalAmount: 0,
    terminalMessages: [],
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    organizationTerminals(state) {
      return state.organizationTerminals;
    },

    terminalGeneral(state) {
      return state.terminalGeneral;
    },
    terminalService(state) {
      return state.terminalService;
    },
    terminalMaintenance(state) {
      return state.terminalMaintenance;
    },
    terminalSchedules(state) {
      return state.terminalSchedules;
    },
    terminalAmount(state) {
      return state.terminalAmount;
    },
    terminalMessages(state) {
      return state.terminalMessages;
    }
  },
  mutations: {
    [types.IS_LOADING]: (state, status) => {
      return (state.isLoading = status);
    },
    [types.UPDATE_ORGANIZATION_TERMINALS]: (state, payload) => {
      return (state.organizationTerminals = payload);
    },

    [types.UPDATE_TERMINAL_GENERAL_DATA]: (state, payload) => {
      return (state.terminalGeneral = payload);
    },
    [types.UPDATE_TERMINAL_SERVICE_DATA]: (state, payload) => {
      return (state.terminalService = payload);
    },
    [types.UPDATE_TERMINAL_MAINTENANCE_DATA]: (state, payload) => {
      return (state.terminalMaintenance = payload);
    },
    [types.UPDATE_TERMINAL_SCHEDULES_DATA]: (state, payload) => {
      if (payload) {
        return state.terminalSchedules = payload
      }
      return state.terminalSchedules = []
    },
    [types.UPDATE_TERMINAL_AMOUNT]: (state, payload) => {
      return (state.terminalAmount = payload);
    },
    [types.UPDATE_TERMINAL_MESSAGES_DATA]: (state, payload) => {
      return (state.terminalMessages = payload);
    }
  },
  actions: {
    async getOrganizationsTerminals({ commit }, payload = {}) {
      let { org_id, params } = payload;
      commit(types.IS_LOADING, true);
      try {
        let resp = await termApi.getOrganizationsTerminals(org_id, params);
        commit(types.UPDATE_ORGANIZATION_TERMINALS, resp.data);
        commit(types.UPDATE_TERMINAL_AMOUNT, resp.headers["x-total-count"]);
      } catch (e) {
        this.$message.error("Ошибка при получении данных организации");
      } finally {
        commit(types.IS_LOADING, false);
      }
    },
    async getTerminalServiceById({ commit }, payload) {
      commit(types.IS_LOADING, true);
      let { term_id, service_id } = payload;
      const resp = await termApi.getTerminalServiceById(term_id, service_id);
      return resp.data;
    },
    async getTerminalData({ commit }, payload) {
      commit(types.IS_LOADING, true);
      let { term_id, dataType = "general" } = payload;
      try {
        let resp = "";
        switch (dataType) {
          case "general":
            resp = await termApi.getTerminalGeneralInfo(term_id);
            commit(types.UPDATE_TERMINAL_GENERAL_DATA, resp.data);
            break;
          case "services":
            resp = await termApi.getTerminalServices(term_id);
            for(let service of resp.data) {
              let mode = ''
              switch (service.code) {
                case 'service-1':
                  mode = 'Режим 1'
                  break
                case 'service-2':
                  mode = 'Режим 2'
                  break
                case 'service-3':
                  mode = 'Режим 3'
                  break
                case 'service-4':
                  mode = 'Режим 4'
                  break
                default:
                  mode = ''
                  break
              }
              service.mode = mode
            }
            commit(types.UPDATE_TERMINAL_SERVICE_DATA, resp.data);
            break

          case "maintenance":
            resp = await termApi.getTerminalMaintenance(term_id);
            commit(types.UPDATE_TERMINAL_MAINTENANCE_DATA, resp.data);
            break;
          case "messages":
            resp = await termApi.getTerminalMessages(term_id);
            commit(types.UPDATE_TERMINAL_MESSAGES_DATA, resp.data);
            break;
        }
      } catch (e) {
        this.$message.error("Ошибка при получении данных терминала");
      } finally {
        commit(types.IS_LOADING, false);
      }
    },
    async getSchedulesData({ commit }, payload) {
      commit(types.IS_LOADING, true);
      commit(types.UPDATE_TERMINAL_SCHEDULES_DATA, false);
      let { term_id, services = [] } = payload;
      let fullResponse= []
      try {
        for (let service of services){
          let resp = await termApi.getTerminalServicesPriceSchedules(term_id, service.id);
          for (let respItem of resp.data){
            respItem.name = service.name
            respItem.start_time = respItem.start_time.slice(0,5);
            respItem.end_time = calculate_end_time(respItem.start_time.slice(0,8), respItem.end_time.slice(0,8));
            respItem.price = `${respItem.price} руб`;
          }
          fullResponse.push( ...resp.data)
        }
        commit(types.UPDATE_TERMINAL_SCHEDULES_DATA, fullResponse);
      } catch (e) {
        this.$message.error("Ошибка при получении данных терминала");
        commit(types.UPDATE_TERMINAL_SCHEDULES_DATA, false);
      } finally {
        commit(types.IS_LOADING, false);
      }
    },

    async postOrganizationsTerminals({ commit }, payload) {
      /*{
     "serial_number": "string",
     "activation_date": "2020-02-11T05:53:42.167Z",
     "activation_code": "string",
     "address": "string"
     }*/
      let { organizationsId, params = {} } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.postOrganizationsTerminals(organizationsId, params);
        commit(types.IS_LOADING, false);
      } catch (e) {
        this.$message.error("Не удалось добавить терминал");
        commit(types.IS_LOADING, false);
      }
    },
    async postTerminalService({ commit }, payload) {
      // {
      //   "code": "string",
      //   "icon": "car-wash-1",
      //   "name": "string",
      //   "full_name": "string",
      //   "price": 0,
      //   "description": "string"
      // }
      let { term_id, params } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.postTerminalService(term_id, params);
        commit(types.IS_LOADING, false);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async postTerminalMaintenance({ commit }, payload) {
      /*  {
          "date": "2020-02-13",
          "note": "string",
          "technician_name": "string",
          "next_date": "2020-02-13"
        }*/
      let { term_id, params } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.postTerminalMaintenance(term_id, params);
        commit(types.IS_LOADING, false);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async postTerminalServicesPriceSchedule({commit}, payload){
    // {
    //   "start_time": "string",
    //     "end_time": "string",
    //     "price": 0
    // }
      const { term_id, service_id, params } = payload;
      commit(types.IS_LOADING, false);
      try {
        await termApi.postTerminalServicesPriceSchedule(term_id, service_id, params);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }

    },

    async patchTerminalService({ commit }, payload) {
      // {
      //   "icon": "car-wash-1",
      //   "name": "string",
      //   "full_name": "string",
      //   "description": "string",
      //   "price": 0
      // }
      let { term_id, service_id, params } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.patchTerminalService(term_id, service_id, params);
        commit(types.IS_LOADING, false);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async patchTerminalMaintenance({ commit }, payload) {
      /*  {
          "date": "2020-02-13",
          "note": "string",
          "technician_name": "string",
          "next_date": "2020-02-13"
        }*/
      let { term_id, maintenance_id, params } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.patchTerminalMaintenance(term_id, maintenance_id, params);
        commit(types.IS_LOADING, false);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async patchTerminalServicesPriceSchedule({commit}, payload) {
    // {
    //   "start_time": "string",
    //     "end_time": "string",
    //     "price": 0
    // }
      const { term_id, service_id, schedule_id, params } = payload;
      commit(types.IS_LOADING, false);
      try {
        return await termApi.patchTerminalServicesPriceSchedule(term_id,
          service_id, schedule_id, params)
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },
    async patchTerminalLock({commit}, payload){
      const { term_id } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.patchTerminalLock(term_id);
      } catch (e) {
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },


    async deleteTerminal({ commit }, payload) {
      let { term_id } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.deleteTerminal(term_id);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async deleteTerminalLock({ commit }, payload) {
      let { term_id } = payload;
      try {
        commit(types.IS_LOADING, true);
        await termApi.deleteTerminalLock(term_id);
      } catch (e) {
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },
    async deleteTerminalService({ commit }, payload) {
      const { term_id, service_id} = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.deleteTerminalService(term_id, service_id);
      } catch (e) {
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },
    async deleteTerminalMaintenance({ commit }, payload) {
      const { term_id, maintenance_id } = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.deleteTerminalMaintenance(term_id, maintenance_id);
        commit(types.IS_LOADING, false);
      } catch (e) {
        commit(types.IS_LOADING, false);
        throw e;
      }
    },
    async deleteTerminalServicesPriceSchedule({ commit }, payload) {
      const { term_id, service_id, schedule_id} = payload;
      commit(types.IS_LOADING, true);
      try {
        await termApi.deleteTerminalServicesPriceSchedule(term_id, service_id, schedule_id);
      } catch (e) {
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },


    async rebootTerminal({ commit }, payload) {
      let { term_id } = payload;
      try {
        commit(types.IS_LOADING, true);
        await termApi.rebootTerminal(term_id);
      } catch (e) {
        throw e;
      }
      finally {
        commit(types.IS_LOADING, false);
      }
    },
  }
};
